export const regionsAU = {
  ACT: "Australian Capital Territory",
  QLD: "Queensland",
  NSW: "New South Wales",
  WA: "Western Australia",
  VIC: "Victoria",
  SA: "South Australia",
  TAS: "Tasmania",
  NT: "Northern Territory",
  JBT: "Jervis Bay Territory"
};

export default regionsAU;
